/* eslint-disable no-null/no-null */
import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
  type ISourceEntity,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard } from '@principle-theorem/shared';
import { flow, isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';

export const CONTACT_RESOURCE_TYPE = 'contact';

export const CONTACT_SOURCE_ENTITY: ISourceEntity = SourceEntity.init({
  metadata: {
    label: 'Contact List',
    description: '',
    idPrefix: CONTACT_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface ID4WContact {
  id: number;
  name: string;
  address: string | null;
  phone: string | null;
  code: string | null;
}

export function isD4WContact(
  item: unknown,
  logError: boolean
): item is ID4WContact {
  return TypeGuard.interface<ID4WContact>(
    {
      id: isNumber,
      name: isString,
      address: TypeGuard.nilOr(isString),
      code: TypeGuard.nilOr(isString),
      phone: TypeGuard.nilOr(isString),
    },
    logError
  )(item);
}

const CONTACT_SOURCE_QUERY = `
SELECT
  third_party_id AS id,
  name,
  NULLIF(address, '') AS address,
  NULLIF(convert_to_text(phone_1), '') AS phone,
  NULLIF(code, '') AS code
FROM third_parties
WHERE third_party_id IS NOT NULL
`;

export type D4WContact = ISourceEntityTypes<ID4WContact>;

export class ContactSourceEntity extends BaseSourceEntity<D4WContact> {
  sourceEntity = CONTACT_SOURCE_ENTITY;
  entityResourceType = CONTACT_RESOURCE_TYPE;
  sourceQuery = CONTACT_SOURCE_QUERY;
  verifySourceFn = isD4WContact;
  override transformDataFn = flow([]);

  translate(_data: ID4WContact): unknown {
    return {};
  }

  getSourceRecordId(data: ID4WContact): string | number {
    return data.id;
  }

  getSourceLabel(data: ID4WContact): string {
    return `${data.name}`;
  }
}
